<template>
    <div>
        <div style="width: 100%;margin-bottom: 20px;">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>商品管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 搜索筛选 -->
        <el-form :inline="true" class="user-search" :model="formInline" size="small">

            <el-form-item label="商品名称">
                <el-input size="small" placeholder="请输入商品名称" v-model="formInline.goodsname"></el-input>
            </el-form-item>

            <el-form-item label="上架状态">
                <el-select v-model="formInline.status" placeholder="默认全部">
                    <el-option label="全部" value='-1'></el-option>
                    <el-option label="下架" value='0'></el-option>
                    <el-option label="上架" value='1'></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="销量">
                <el-input v-model="formInline.mixSale" style="width: 80px;"></el-input>
                -
                <el-input v-model="formInline.maxSale" style="width: 80px;"></el-input>
            </el-form-item>
            <el-form-item label="价格">
                <el-input v-model="formInline.minpreice" style="width: 80px;"></el-input>
                -
                <el-input v-model="formInline.maxpreice" style="width: 80px;"></el-input>
            </el-form-item>


            <!-- <el-form-item label="一级分类">
                <el-select v-model="formInline.status" placeholder="默认全部">
                  
                    <el-option label="下架" value='0'></el-option>
                    <el-option label="上架" value='1'></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="二级分类">
                <el-select v-model="formInline.status" placeholder="默认全部">
                    <el-option label="下架" value='0'></el-option>
                    <el-option label="上架" value='1'></el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                <el-button size="small" type="warning" icon="el-icon-delete" @click="add">新增</el-button>
                <el-button size="small" type="warning" icon="el-icon-delete" @click="clear">清空刷选条件</el-button>

            </el-form-item>
        </el-form>

        <!--列表-->
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" type="selection" width="60">
            </el-table-column>
            <el-table-column prop="coverImg" label="商品信息" width="150" align="center">
                <template slot-scope="scope">
                    <div>
                        <el-image style="width: 80px; height: 80px" :src="scope.row.coverImg">
                        </el-image>
                    </div>
                    <div>{{scope.row.goodsName}}</div>
                </template>

            </el-table-column>
            <el-table-column prop="salePrice" label="商品价格" width="150" align="center">
                <template slot-scope="scope">

                    <div style="color:red">出售价：{{scope.row.salePrice}}</div>
                    <div style="color:red">划线价：{{scope.row.marketPrice}}</div>
                    <div style="color:red">Vip价：{{scope.row.vipPrice}}</div>

                </template>
            </el-table-column>
            <el-table-column prop="seeNum" label="访问量" width="200" align="center">
                <template slot-scope="scope">

                    <div>访问量：{{scope.row.seeNum}}</div>
                    <div>访客数：{{scope.row.visitNum?scope.row.visitNum:0}}</div>
                </template>
            </el-table-column>

            <el-table-column prop="stock" label="库存" width="100" align="center">
            </el-table-column>
            <el-table-column prop="saleNum" label="总销量" width="100" align="center">
            </el-table-column>

            <!-- <el-table-column sortable label="所属分组" width="200" align="center">
                <template slot-scope="scope">
                    <div>
                        <el-image style="width: 80px; height: 80px" :src="scope.row.user_img">
                        </el-image>
                    </div>
                    <div>{{scope.row.user_name}}</div>
                </template>
            </el-table-column> -->
            <el-table-column prop="createTime" label="创建时间" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{web.formatTime(scope.row.createTime,'Y-M-D h:m')}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="上架时间" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{web.formatTime(scope.row.createTime,'Y-M-D h:m')}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="isSale" label="状态" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{scope.row.isSale==1?'上架':'下架'}}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" min-width="300">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" icon="el-icon-edit"
                        @click="handleedit(scope.$index, scope.row)">编辑</el-button>
                    <el-button size="mini" type="info" @click="setStatus(scope.row)">{{scope.row.isSale==1?'下架':'上架'}}</el-button>
                    <el-button size="mini" type="primary" icon="el-icon-delete"
                    @click="handledelete(scope.$index, scope.row)">删除</el-button>
               
                    <el-button size="mini" type="danger" icon="el-icon-setting"
                        @click="handlespec(scope.$index, scope.row)">规格编辑</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>

        <!-- 弹框 -->
      
    </div>
</template>

<script>
  
    import { selectGoodsList, addEditGoods, deleteGoods, getAllCategory ,initGoodsSpecs, getGoodsSpecsGroupVaule} from '../../api/basisMG.js'
    import Pagination from '../../components/Pagination'
  
    // 导出模块
    export default {
        components: {
            Pagination,
           
        },
        // 模块数据
        data() {
            //数据  
            return {
                loading: false,
                Visible: false,

                // formInline: {
                //     start: 0,
                //     length: 5,
                //     goodsname: '',
                //     status: '',
                //     mixSale: null,
                //     maxSale: null,
                //     minpreice: null,
                //     maxpreice: null,
                //     cateId: '',
                //     cateId2: '',
                // },
                fileList: [],
                listData: [],
                dialogImageUrl: '',
                dialogVisible: false,
                // 分页参数
                // pageparm: {
                //     currentPage: 1,
                //     pageSize: 5,
                //     total: 10,
                //     start: 0,
                //     length: 5
                // },
                // 所属分类
                tableData: [],
                value: [],
                editForm: {
                    goodsId: '',
                    goodstype: '',
                    goodsName: '',
                    des: '',
                    SelectValue: '',
                    goodsdes: '',
                    sellPoint: '',
                    specications: '',
                    price: null,
                    marketPrice: null,
                    stock: 999,
                    saleNum: 0,
                    purchaseLimit: 0,
                    day: '',
                    time: '',
                    imglunbo: '',
                    videoUrl: '',
                    videoImg: '',
                    mainImg: '',
                    indexImg: '',
                    freightFee: '',
                    cateId: null,
                    cateId2: null,
                    stockThresholdType: null,
                    stockThreshold: 100,
                    uploadData: []
                }
            }
        },


        watch: {},

        methods: {
            submitreplyForm() {
                console.log(this.editForm)
                addEditGoods(this.editForm).then(res => {
                    if (res.code == '200') {
                        this.listData = res.data.content
                        this.pageparm.total = res.data.totalElements
                        this.getdata()
                    }
                })
            },
            // initGoodsSpecs
            initGoodsSpecs() {
                console.log(this.editForm)
                initGoodsSpecs({goodsId: 108,spec1:'a,b,c,d',spec2:'e,f',spec3:'麻辣'}).then(res => {
                    console.log(res)
                    // if (res.code == '200') {
                    //     this.listData = res.data.content
                    //     this.pageparm.total = res.data.totalElements
                    //     this.getdata()
                    // }
                })
            },
            // 单个图片上传可用
            upload(data, cateName, limit) {
                if (limit == 1) {
                    this.editForm[cateName] = data[0].response.data
                }

                console.log(data, cateName)
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            //  图片上传
            handleRemove(file, fileList) {
                // this.editForm.fileList = fileList
                this.fileList = fileList
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleSuccess(response, file, fileList) {

                this.fileList = fileList
                this.dialogImageUrl = response.data


            },
            handleSuccess1(response, file, fileList) {

                this.uploadData = fileList
                this.editForm.indexImg = response.data

            },
            changecascader(e) {
                console.log(e)

            },
            getContent(content) {

                this.editForm.des = content
            },
            getCategory() {
                //   获得商品分类列表
                getAllCategory().then(res => {
                    if (res.code == '200') {
                        this.tableData = res.data

                    }

                })
            },


            // 评论框
            closeDialog() {
                this.Visible = false

            },
            setStatus(row) {
                this.editForm = Object.assign({}, row)
                this.editForm.isSale = row.isSale == 1 ? 0 : 1
                let msg=  row.isSale == 1?'下架':'上架'
                addEditGoods(this.editForm).then(res => {
                    if (res.code == '200') {
                       this.$message({
                           message:msg+'成功',
                           type:'success'
                       })
                       this.getdata(this.formInline)
                    }
                })

            },
            postopen() { },
            // 获得商品数据
            getdata(params) {
                let param = params
              
                selectGoodsList(param).then(res => {
                    if (res.code == '200') {
                        this.listData = res.data.content
                        this.pageparm.total = res.data.totalElements
                    }
                })

            },
            add() {
                this.$router.push({path:'/product/productedit'})
                // this.Visible = true
                // console.log('add')
                // this.editForm = {}
            },
            // 获得商品数据
            addEdit() {
                this.Visible = true
            },
            handlespec(index, row){
                console.log(index,row)
                this.$router.push({path:'/product/productsx',query: {good: JSON.stringify(row)}})
                getGoodsSpecsGroupVaule({goodsId:row.goodsId}).then(res => {
                    console.log(res)
                // let formLine={}
                
                // formLine.spec0 = res.data.spec0
                // formLine.spec1 = res.data.spec1
                // formLine.spec2 = res.data.spec2
                // this.$router.push({path:'/product/productsx',query: {good: JSON.stringify(row),formLine:JSON.stringify(formLine)}})
    })
                
            },
        
            handleedit(index, row) {
                // this.Visible = true
                this.editForm = Object.assign({}, row)
                let list = []
                if(row.bannerImg){
                    list = row.bannerImg.split(",")  
                }
               
              
                list.forEach(item => {
                    // this.fileList.push({name:'item'+index,url:item,response:{data:item}})
                    this.fileList.push(this.web.obj(item))
                })
                if(row.bannerImg){
                    this.editForm.fileList = row.bannerImg.split(",")    
                }
               
               
                this.$router.push({path:'/product/productedit',query: {editForm: JSON.stringify(this.editForm),id:1}})
                console.log(this.editForm.fileList)
                console.log(index, row)
            },
            handledelete(index, row) {
                console.log(index, row)
                deleteGoods({ goodsId: row.goodsId }).then(res => {
                    console.log(res)
                    if (res.code == 200) {
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        })
                        this.getdata(this.formInline)
                    }

                })
            },
            // 查询
            // search() {
            //     this.formInline.start = 0
			// 	this.pageparm.currentPage = 1
            //     this.getdata(this.formInline)
            // },
            // 清空
            // clear() {
            //     this.formInline = {
            //         start: 0,
            //         length: 10,
            //         goodsname: '',
            //         status: '',
            //         mixSale: null,
            //         maxSale: null,
            //         minpreice: null,
            //         maxpreice: null,
            //         cateId: '',
            //         cateId2: '',
            //     },
            //         this.getdata(this.formInline)
            // },

            // 分页插件事件
            // callFather(parm) {
            //     this.pageparm.currentPage  = parm.currentPage
            //     this.pageparm.pageSize =  parm.pageSize 
            //     this.pageparm.start  = parm.currentPage - 1
            //     this.pageparm.length =  parm.pageSize 
            //     this.formInline.start = parm.currentPage - 1
            //     this.formInline.length = parm.pageSize
            //     this.getdata(this.formInline)
            // },
            addFun() { },
            submitFun() { }
        },
        // 创建前状态(里面是操作)
        beforeCreate() { },
        // 创建完毕状态(里面是操作)
        created() {
            this.getdata(this.formInline)
            this.getCategory()
            // this.initGoodsSpecs()
        },
        // 挂载前状态(里面是操作)
        beforeMount() { },
        // 挂载结束状态(里面是操作)
        mounted() { },
        // 更新前状态(里面是操作)
        beforeUpdate() { },
        // 更新完成状态(里面是操作)
        updated() { },
        // 销毁前状态(里面是操作)
        beforeDestroy() { },
        // 销毁完成状态(里面是操作)
        destroyed() { }
    };
</script>

<style scoped>
    .el-form-item {
        width: 40%;
        box-sizing: border-box;
    }

    .just-start {
        display: flex;
        justify-content: flex-start;
    }

    .marginT20 {
        margin-top: 20px;
    }
</style>